var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatNeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    transform: "scale(-1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6002_18878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.24998 3.94238V6.44238M1.24998 6.44238H3.75M1.24998 6.44238L5.25 2.44238L7.25 4.44238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6002_18878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "matrix(-1 0 0 -1 8.75 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatNeg);
export default __webpack_public_path__ + "static/media/StatNeg.2f73f069a236a593b12e598bcae9663c.svg";
export { ForwardRef as ReactComponent };